import React, {useMemo} from 'react';
import {EnsureLoggedIn} from "./EnsureLoggedIn";
import {Tabs, TabsProps} from 'antd';
import {EventsEditor} from "../events/EventsEditor";
import {Reservations} from "../reservation/Reservations";
import {GamesAdministration} from "../games/GamesAdministration";
import {LauncherLayout} from "../launcher/layout/LauncherLayout";
import {useAuthContext} from "../launcher/auth/LauncherAuthContext";
import {UsersAdministration} from "./users/UsersAdministration";
import {AssetsAdministration} from "./assets/AssetsAdministration";
import {Label} from "../commons/translations/Label";
import {OrganizersAdministration} from "./organizers/OrganizersAdministration";

export const Administration: React.FC = () => {

    const { isAdmin } = useAuthContext();
    const menuItems = useMemo<TabsProps["items"]>(() => {

        const basicItems: TabsProps["items"] = [
            {
                key: '-',
                label: <Label trl="admin.tabs.events" />,
                children: <EventsEditor />
            },{
                key: '-',
                label: <Label trl="admin.tabs.reservations" />,
                children: <Reservations />
            },{
                key: '-',
                label: <Label trl="admin.tabs.games" />,
                children: <GamesAdministration />
            },{
                key: '-',
                label: <Label trl="admin.tabs.assets" />,
                children: <AssetsAdministration />
            },{
                key: '-',
                label: <Label trl="admin.tabs.organizers" />,
                children: <OrganizersAdministration />
            }];

        const superAdminItems: TabsProps["items"] = [{
            key: '-',
            label: <Label trl="admin.tabs.users" />,
            children: <UsersAdministration />
        }];

        const final: TabsProps["items"] = [];

        if (isAdmin()) {
            final.push(...superAdminItems);
        }
        final.push(...basicItems);

        final.forEach((item, index) => {
            item.key = index.toString();
        });

        return final;
    }, [isAdmin]);
    return(
      <EnsureLoggedIn shouldBeAdmin={true}>
          <LauncherLayout disableBackground={true}>
              <Tabs
                  style={{ backgroundColor: 'white', padding: '0.5em' }}
                  size={"small"}
                  defaultActiveKey="0"
                  type={"card"}
                  items={menuItems}
              />
          </LauncherLayout>
      </EnsureLoggedIn>
    );
}